<template>
    <div>
        <!-- <b-card no-body v-if="perfilGestor">
            <b-card-body>
                <h5 class="heading-1 mb-4">
                    <span
                        >PRAZOS PARA SOLICITAÇÕES DE ADITIVOS DAS
                        ETAPAS</span
                    >
                </h5>
                <pnl-vencimentos-etapas
                    :pnlVencimentos="pnlVencimentos"
                    v-if="perfilGestor"
                    @filtrarPorPeriodo="$emit('filtrarPorPeriodo', $event)"
                >
                </pnl-vencimentos-etapas>
            </b-card-body>
        </b-card> -->
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">Etapas</span>
                    </b-card-header>
                    <b-card-body>
                        <b-row>
                            <!-- <b-col>
                                <b-form-group>
                                    <strong>
                                        <label>Filtro por Faturamento</label>
                                    </strong>
                                    <b-form-select
                                        :plain="true"
                                        :options="statusFaturamentoSelect"
                                        v-model="statusFaturamento"
                                    ></b-form-select>
                                </b-form-group>
                            </b-col> -->
                            <!-- <b-col sm="6">
                                <b-form-group>
                                    <strong>
                                        <label>Filtro por Status</label>
                                    </strong>
                                    <b-form-select
                                        :plain="true"
                                        :options="statusEtapasSelect"
                                        v-model="statusEtapa"
                                    ></b-form-select>
                                </b-form-group>
                            </b-col> -->
                        </b-row>
                        <app-tabela
                            idTabela="tblEtapas"
                            :itens="etapasFiltradas"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false"
                        >
                            <template slot="botoes">
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="status" slot-scope="data">
                                <app-status
                                    :status="data.status.toUpperCase()"
                                ></app-status>
                            </template>
                            <template slot="valorHora" slot-scope="data">{{
                                data.valorHora | currency
                            }}</template>
                            <template slot="valorDespesas" slot-scope="data">{{
                                data.valorDespesas | currency
                            }}</template>
                            <template slot="idMov" slot-scope="data">
                                {{ data.idMov }}
                                <status-id-mov :etapa="data"></status-id-mov>
                                <btn-erro-comprometimento
                                    :etapa="data"
                                    :servicos="servicos"
                                    :permiteAcesso="
                                        permiteAcessoErroComprometimento
                                    "
                                ></btn-erro-comprometimento>
                                <btn-excluir-comprometimento
                                    :etapa="data"
                                    :servicos="servicos"
                                    :permiteExcluir="
                                        permiteExcluirComprometimento
                                    "
                                    @obterAtualizacao="
                                        $emit('obterAtualizacao')
                                    "
                                ></btn-excluir-comprometimento>
                            </template>
                            <template slot="valorTotal" slot-scope="data">{{
                                data.valorTotal | currency
                            }}</template>
                            <template slot="acoes" slot-scope="data">
                                <slot name="etapaAcoes" v-bind="data"></slot>
                                <btn-to-detalhar
                                    :etapa="data"
                                    :projeto="projeto"
                                    :rotaDetalhar="rotaDetalhar"
                                    :permiteAcesso="permiteAcessoDetalhar"
                                ></btn-to-detalhar>
                                <btn-to-documentacao
                                    :etapa="data"
                                ></btn-to-documentacao>                              
                                <etapas-time-line
                                    :etapasServicos="servicos"
                                    :etapa="data"
                                ></etapas-time-line>
                                <historico
                                    titulo="Histórico da Etapa"
                                    tipo="I"
                                    :servicos="servicos"
                                    :id="data.etapaId"
                                    class="ml-2"
                                    v-if="permiteAcessoHistorico"
                                ></historico>
                                <slot name="etapaAcoes" v-bind="data"></slot>
                                <btn-to-rateio
                                    :etapa="data"
                                    :rotaRateio="rotaRateio"
                                    :permiteAcesso="permiteAcessoRateio"
                                ></btn-to-rateio>
                                <btn-msg-cancelamento
                                    :etapa="data"
                                ></btn-msg-cancelamento>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import StatusIdMov from './StatusIdMov'
import BtnErroComprometimento from './BtnErroComprometimento'
import BtnExcluirComprometimento from './BtnExcluirComprometimento'
import BtnMsgCancelamento from './BtnMsgCancelamento'
import BtnToRateio from './BtnToRateio'
import BtnToDetalhar from './BtnToDetalhar'
import EtapasTimeLine from './EtapasTimeLine'
import BtnToDocumentacao from './BtnToDocumentacao'
import Historico from '../../../../shared/components/Historico'

export default {
    components: {
        StatusIdMov,
        BtnErroComprometimento,
        BtnExcluirComprometimento,
        BtnMsgCancelamento,
        BtnToRateio,
        EtapasTimeLine,
        BtnToDetalhar,
        BtnToDocumentacao,
        Historico
    },

    props: {
        projeto: {
            type: Object,
            default: () => ({})
        },
        etapas: {
            type: Array,
            default: () => []
        },

        servicos: {
            type: Object,
            default: () => ({})
        },

        rotaRateio: {
            type: String
        },

        rotaDetalhar: {
            type: String
        },

        permiteAcessoRateio: {
            type: Boolean,
            default: () => false
        },
        
        permiteAcessoDetalhar: {
            type: Boolean,
            default: () => false
        },

        permiteExcluirComprometimento: {
            type: Boolean,
            default: () => false
        },

        permiteAcessoErroComprometimento: {
            type: Boolean,
            default: () => false
        },

        permiteAcessoHistorico: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            statusEtapa: 'TODAS',
            statusFaturamento: 'TODAS',
            statusFaturamentoSelect: ['TODAS', 'PAGAS', 'EM ABERTO'],
            statusEtapasSelect: [],
            etapasFiltradas: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'idEtapa',
                    label: 'Parcela',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'idEtapaCliente',
                    label: 'Etapa',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'cliente',
                    label: 'Cliente',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'servico',
                    label: 'Serviço',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'natureza',
                    label: 'Tipo Natureza',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'inicioEtapa',
                    label: 'Início',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'terminoEtapa',
                    label: 'Término',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'horasEtapa',
                    label: 'Qtd Horas',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'valorHora',
                    label: 'Valor Hora',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'qtdDespesas',
                    value: 'Qtd Despesas',
                    tdClass: 'text-center'
                },
                {
                    key: 'valorDespesas',
                    label: 'Valor Despesas',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'status',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'idMov',
                    label: 'Comprometimento',
                    filterable: true
                },
                {
                    key: 'pagamento',
                    label: 'Registro de Pagamento'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-center'
                }
            ],
            itensPorPagina: 0,
            exibirTimeline: false
        }
    },

    methods: {
        processarFiltro() {
            let etapasTemp = [...this.etapas]
            if (this.statusFaturamento != 'TODAS') {
                if (this.statusFaturamento == 'PAGAS') {
                    etapasTemp = etapasTemp.filter(
                        (p) => p.statusIdFat == 'F' || p.statusIdFat == 'Q'
                    )
                }
                if (this.statusFaturamento == 'EM ABERTO') {
                    etapasTemp = etapasTemp.filter(
                        (p) => p.statusIdFat != 'F' && p.statusIdFat != 'Q'
                    )
                }
            }
            if (this.statusEtapa != 'TODAS') {
                etapasTemp = etapasTemp.filter(
                    (p) => p.status == this.statusEtapa
                )
            }
            this.etapasFiltradas = [...etapasTemp]
        }
    },

    computed: {},

    created() {},

    watch: {
        etapas() {
            this.statusEtapasSelect = _.uniq(_.map(this.etapas, 'status'))
            this.statusEtapasSelect.unshift('TODAS')
            this.processarFiltro()
        },

        statusEtapa() {
            this.processarFiltro()
        },

        statusFaturamento() {
            this.processarFiltro()
        }
    }
}
</script>
